import { render, staticRenderFns } from "./NotificationNotEnabledMessage.vue?vue&type=template&id=c40338ca&scoped=true"
import script from "./NotificationNotEnabledMessage.vue?vue&type=script&lang=js"
export * from "./NotificationNotEnabledMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationNotEnabledMessage.vue?vue&type=style&index=0&id=c40338ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40338ca",
  null
  
)

export default component.exports